import { render } from "./backgroundText.vue?vue&type=template&id=eac72718"
import script from "./backgroundText.vue?vue&type=script&lang=js"
export * from "./backgroundText.vue?vue&type=script&lang=js"

import "./backgroundText.vue?vue&type=style&index=0&id=eac72718&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__